import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import "swiper/css";
import "swiper/css/pagination";
//import "swiper/css/free-mode";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import useWindowsSize from "@/Hooks/useWindowsSize";
import type React from "react";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ImageCarousel } from "@/Components/Index";
import { changeImagenParams } from "@/Utils/Product.Image.View";

type Props = {
  mDatos: ProductByIdPdp[];
  closeModals: () => void;
  isLoading: boolean;
};

export const ModalViewImage = ({
  mDatos,
  closeModals,
  isLoading,
}: Props): JSX.Element => {
  //Current - Id del Iamgen en Modal
  const [currentIndexModal, setCurrentIndexModal] = useState<number>(0);
  //screen w & h
  const { height } = useWindowsSize();
  //Obtenemos los datos de las imagenes.
  const imageZoomGroupss = mDatos[0]?.ImageZoomGroups[0]?.images;
  const imageGroupss = mDatos[0]?.ImageGroups[0]?.images;
  const imageDefault = mDatos[0]?.Default ? mDatos[0]?.Default : "";

  const closeModal = (e: React.MouseEvent<HTMLDivElement>) => {
    const { id } = e.target as HTMLDivElement;
    if (id == "modal-overlay") {
      setCurrentIndexModal(0);
      closeModals();
    }
  };

  const closeModalButton = () => {
    setCurrentIndexModal(0);
    closeModals();
  };

  const handlesSlideChange = (swiper: SwiperType) => {
    setCurrentIndexModal(swiper.activeIndex);
  };

  return (
    <div id="modal-overlay" className="modal-overlay" onClick={closeModal}>
      <div className={height < 1580 ? "modal-header" : "modal-header-Superior"}>
        <span
          className={
            height < 1580
              ? "text-white"
              : "text-white clase-span-number d-flex align-self-center ml-3"
          }>
          {currentIndexModal + 1}/{imageZoomGroupss?.length}
        </span>
        <button
          className={
            height < 1580 ? "close-button" : "close-button-superior mr-5"
          }
          onClick={closeModalButton}>
          &times;
        </button>
      </div>
      <div className="modal-content">
        <div className="image-container text_Center___develop">
          <Swiper
            loop={false}
            modules={[Navigation, Pagination, Scrollbar]}
            onSlideChange={handlesSlideChange}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}>
            {imageGroupss?.map((x, i) => (
              <SwiperSlide key={i}>
                {isLoading ? (
                  <Skeleton width={400} height={400} />
                ) : (
                  <ImageCarousel
                    srcx={changeImagenParams(x.link, 1500, 1500, 99)}
                    altx={x.alt}
                    classNames={"modal_imagen__develop"}
                    srcDefault={imageDefault}
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};
